export default {
  locale: "pt",
  timezone: "America/Sao_Paulo",
  library_path: "tradingview/charting_library/",
  // datafeed: Datafeed,
  // symbol: "WINFUT",
  // interval: "M10",
  // width: window_width,
  // height: window_height,
  // fullscreen: true,
  autosize: true,
  // loading_screen: { backgroundColor: "#171B25" },
  // favorites: {
  //   // intervals: ["1D", "3D", "3W", "W", "M"],
  //   chartTypes: ["Area", "Line"],
  // },
  // fullscreen: true,
  // debug: true,
  // --------------------
  loading_screen: {
    backgroundColor: "#171B26",
    foregroundColor: "#07A4FF",
  },
  // --------------------
  enabled_features: [
    "seconds_resolution",
    "tick_resolution",
    "move_logo_to_main_pane",
    "study_templates",
    "request_only_visible_range_on_reset",
    "always_show_legend_values_on_mobile",
    "show_zoom_and_move_buttons_on_touch",
    // https://www.tradingview.com/charting-library-docs/latest/customization/Featuresets#show_symbol_logos
    // https://www.tradingview.com/charting-library-docs/latest/ui_elements/Symbol-Search/#display-logos
    // "show_symbol_logos", //mostrar logo do ativo
    // "show_exchange_logos", //mostrar logo da exchange
  ],
  disabled_features: [
    "symbol_search_hot_key", //Permite abrir a Pesquisa de Símbolos usando as teclas de digitação.
    "save_chart_properties_to_local_storage",
    "volume_force_overlay",
    //-
    "use_localstorage_for_settings",
    "left_toolbar",
    "header_widget",
    "timeframes_toolbar",
    "edit_buttons_in_legend",
    "context_menus",
    "control_bar",
    "border_around_the_chart",
  ],
  overrides: {
    // "scalesProperties.fontSize": 14,

    // priceScaleSelectionStrategyName: "left",
    // "paneProperties.legendProperties.showVolume": true,
    "paneProperties.legendProperties.showSeriesOHLC": true,

    // https://www.tradingview.com/charting-library-docs/latest/customization/overrides/chart-overrides/#chart-background-color
    // volumePaneSize: "tiny",
    // Cor de fundo gradiente
    // "paneProperties.backgroundGradientStartColor": "#020024",
    // "paneProperties.backgroundGradientEndColor": "#4f485e",
    // Cor de fundo sólida
    // "paneProperties.background": "#020024",
    // "paneProperties.backgroundType": "solid",
    //

    "paneProperties.vertGridProperties.color": "#182029",
    "paneProperties.horzGridProperties.color": "#182029",
    "scalesProperties.textColor": "#AAA",
    // Transparência do cursor (crosshair)
    "paneProperties.crossHairProperties.color": "#5d6268",
    "paneProperties.crossHairProperties.transparency": 100,
    //
    // shape: "arrow_up" e "arrow_down"
    "linetoolarrowmarkup.arrowColor": "#FCEB3C",
    "linetoolarrowmarkdown.arrowColor": "#FCEB3C",
  },
  theme: "dark",
  custom_css_url: "/css/themed.css", //folder "public"
  // settings_adapter: {
  //   // initialSettings: {
  //   //   symbolWatermark:
  //   //     '{ "visibility": "true", "color": "rgba(255, 255, 255, 0.15)" }',
  //   // },
  //   setValue: (key, value) => {},
  //   removeValue: (key) => {},
  // },
  studies_overrides: {
    "volume.volume.transparency": 0,
    // "volume.volume.color.0": this.$colors.red[600],
    // "volume.volume.color.1": this.$colors.green[600],
    // Style das barras de volume
    // "volume.volume.color.0": "#10F9E0",
    // "volume.volume.color.1": "#1029F9",
  },
  // *****************
  // *****************
};
